module.exports = __webpack_public_path__ + "static/excluding9-f9d7c139bf5e3ee921da0b17ac76951b.png";